
import { Component, Input, OnInit } from '@angular/core';
import { LocationItem } from 'src/app/_models/locationItem';
import { EnumService } from 'src/app/services/enum.service';
import { SharedDataService } from 'src/app/services/shared-data.service';
import { User } from 'src/app/_models';
import { ApiService } from 'src/app/services/api.service';
import { AccountService } from 'src/app/services/account.service';

@Component({
  selector: 'app-tree-list',
  templateUrl: './tree-list.component.html',
  styleUrls: ['./tree-list.component.scss'],
})
export class TreeListComponent implements OnInit {
  user: User;

  ngOnInit(): void { }

  @Input() treeData: TreeNode;
  @Input() childCallBack: any;

  fileData = EnumService.PdfDataTemplate
  isOpen = false;

  constructor(
    public sharedDataService: SharedDataService,
    public apiService: ApiService,
    public accountService: AccountService
  ) {
    this.user = this.accountService.userValue;
  }

  toggle() {
    if (!this.treeData.parent) {
      this.isOpen = true;
    } else if (this.treeData?.id.includes('F')) {
      this.isOpen = !this.isOpen;
    } else {
      this.openLocation(this.treeData);
    }
  }

  openLocation(location: TreeNode) {
    const formattedLocation = {
      currentUTCDate: location.currentUTCDate,
      locationAutoCheckOutHour: location.locationAutoCheckOutHour,
      locationAutoCheckOutTime: location.locationAutoCheckOutTime,
      locationID: location.id,
      locationName: location.text,
    };
    this.sharedDataService.checkinLocationByOption =
      EnumService.CheckInLocationByOptions.List;
    this.sharedDataService.checkInForLocation = formattedLocation;
    
    if(this.sharedDataService.relaunchCheckin){
      this.checkFormInEntity()
    }
    this.sharedDataService.getCheckinDetails(
      this.user?.userId,
      this.apiService
    );
    
  }
  checkFormInEntity = async (callBack = null) => {
    //For forms such as work permits, which are valid in this entity but not part of it's personal mode collection
    
    const locationId =  parseInt(this.sharedDataService.checkInForLocation.locationID.split("|")[1])
    for (let location of this.getFormEntityIds()){
      if (location == locationId){
        this.sharedDataService.relaunchFormFoundInEntity = true
      }
    }
  }
  getFormEntityIds(){
    const validEntities:number[] = []
    //console.log(this.fileData.formData.formDetailViewModels.personalModeAssignedItemList)
    if (this.fileData?.formData?.formDetailViewModels?.personalModeAssignedItemList){
      for (let entity of this.fileData.formData.formDetailViewModels.personalModeAssignedItemList){
        if(entity.locationID != null && entity.locationID != undefined && entity.locationID != 0){
          validEntities.push(entity.locationID)
        } else if (entity.projectID != null && entity.projectID != undefined && entity.projectID != 0){
          validEntities.push(entity.projectID)
        }else if (entity.inventoryItemID != null && entity.inventoryItemID != undefined && entity.inventoryItemID != 0){
          validEntities.push(entity.inventoryItemID)
        }
      }
    }
    // Also check folderResolvedEntities if available
    if (this.fileData?.formData?.formDetailViewModels?.folderResolvedEntities){
      for (let entity of this.fileData.formData.formDetailViewModels.folderResolvedEntities){
        if (entity.locationID != null && entity.locationID !== 0){
          validEntities.push(entity.locationID)
        } else if (entity.projectID != null && entity.projectID !== 0){
          validEntities.push(entity.projectID)
        } else if (entity.inventoryItemID != null && entity.inventoryItemID !== 0){
          validEntities.push(entity.inventoryItemID)
        }
      }
    }
    return validEntities
  }
  

  toggleNode(node: TreeNode) {
    // Check if it's a folder (has children)
    if (node.children && node.children.length > 0) {
      node.isOpen = !node.isOpen;
    }
  }
}

export interface TreeNode {
  id: string;
  text: string;
  children?: TreeNode[];
  isOpen?: boolean;
  parent?: string;
  currentUTCDate: string;
  locationAutoCheckOutHour: number;
  locationAutoCheckOutTime: string | null;
}
